import {FlagProps} from 'platform/components';
import {match} from 'ts-pattern';

import {always, isNil} from 'ramda';

import {RentalOrderResponseBody} from '@dms/api/rental';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

export const getRentFromFlags = (
  rentalOrder: RentalOrderResponseBody | Nullish
): FlagProps[] | undefined => {
  if (isNil(rentalOrder)) {
    return undefined;
  }

  const stateFlag = match<RentalOrderResponseBody['state'], FlagProps>(rentalOrder.state)
    .with(
      'draft',
      'reserved',
      always({
        colorScheme: 'neutral',
        label: i18n.t('page.rentalOrder.labels.scheduled'),
      })
    )
    .with(
      'canceled',
      always({
        colorScheme: 'red',
        label: i18n.t('page.rentalOrder.labels.canceled'),
      })
    )
    .otherwise(
      always({
        label: i18n.t('page.rentalOrder.labels.rented'),
        colorScheme: 'blue',
      })
    );

  return [stateFlag];
};
